'use client';

import { LanguageProvider } from '@/i18n/LanguageProvider';
import type { Locale } from '@/i18n/config';

export default function Providers({
  children,
  initialLocale,
}: {
  children: React.ReactNode;
  initialLocale?: Locale;
}) {
  return <LanguageProvider initialLocale={initialLocale}>{children}</LanguageProvider>;
}
